// removed by extract-text-webpack-plugin
module.exports = {"Burger":"_3K4F-Qd9PP5cwDxK60_fC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/Burger.css
// module id = 120
// module chunks = 0